module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc( "UnitSearch", "Search for a device" ) ))==null?'':__t)+
'</legend></fieldset><fieldset><label for="registration-number-input">'+
((__t=( i18n.tc( "UnitSearch", "Registration number:" ) ))==null?'':__t)+
'</label> <input type="text" id="registration-number-input" name="registration-number-input" data-input="registration-number"><div class="input"><small><a href="#" data-click="search-serial">'+
((__t=( i18n.tc( "UnitSearch", "Search by serial number" ) ))==null?'':__t)+
'</a></small></div></fieldset><fieldset class="button-wrap"><button class="primary" data-click="registration-submit">'+
((__t=( i18n.tc( "UnitSearch", "Search" ) ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
